import { ComponentClass } from 'react';
import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';
export { ComponentClass };

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "RSVP" */ './lazyIndex'));

export const lazyTryPrefetchMeetingMessage = new LazyAction(
    lazyModule,
    m => m.tryPrefetchMeetingMessage
);

export const lazyRemoveMeetingMessagesFromStore = new LazyAction(
    lazyModule,
    m => m.removeMeetingMessagesFromStore
);

export const MeetingMessageButton = createLazyComponent(lazyModule, m => m.MeetingMessageButton);
